export const timeFormatter = ({
  timeStyle = 'short',
  timeZone,
}: {
  timeStyle?: 'short' | 'medium' | 'long' | 'full';
  timeZone?: string;
}) =>
  new Intl.DateTimeFormat('en-US', {
    timeStyle,
    timeZone,
  });
